import React from 'react';
import Parent from '../parent';
import { withTranslation } from 'react-i18next';
import BackNextBar from './backNextBar';
import {BllinkLogger} from '../utils/bllink_loggers';
import UnpaidMonths from './unPaidMonths';
import MonthsRelatedLogic from './monthsRelatedLogic';
import { constants } from "../constants/constants";
import AllPaid from './allPaid';
import MonthRelatedSelectBox from "./monthRelatedSelectBox";
import AddFastPayment from './fastOneTime/addFastPayment';

export class DebtPaymentsSection extends Parent {

    constructor(props) {
        super(props);

        this.typOfPayment = constants.cache.keys.payments.pastPayments;
        this.state = this.newState(props);
        this.state.isAdmin = false;
        this.debtInputChangedFunc = this.debtInputChanged.bind(this);
    }

    async componentDidMount() {
        const isManager = await this.isLoggedIn();
        const isAdmin = await this.isAdmin();
        this.setState({
            isAdmin,
            isManager
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.setState(this.newState(this.props));
        }
    }

    debtInputChanged(e){
        /*

        */

        const monthsSelected = MonthsRelatedLogic.alignDebtSelectedStatus(this.state.debtMonths);
        BllinkLogger.info(`monthsSelected before caching `, monthsSelected)

        // cache current selected months
        MonthsRelatedLogic.cacheCurrentSelectedMonths(
            monthsSelected,
            this.typOfPayment,
            this.state.buildingID,
            this.state.apartmentNumber
        )

        BllinkLogger.info('state', this.state)
        // to rerender the page
        this.setState(this.newState({
            buildingID: this.state.buildingID,
            apartmentNumber: this.state.apartmentNumber
        }))

    }

    newState(props){

        const payments = props.payments || this.state.payments || {};
        const totalDebtObj = payments.totalDebt || {};
        let debtMonths = payments.paymentsSortedArray || [];
        const debtMonthsFinal = MonthsRelatedLogic.fetchSelectedMonthsFromCache(
            debtMonths,
            this.typOfPayment,
            props.buildingID,
            props.apartmentNumber
        )
        BllinkLogger.info(`after considering cache `, debtMonthsFinal.map((x) => x.selected))

        const totalAmountSelected = MonthsRelatedLogic.calcTotalAmountSelected(debtMonthsFinal);
        const totalAmountCurrency = debtMonthsFinal[0]?.total.currency;
        const totalDebt = this.BllinkUtils.Strings.numberWithCommas(payments.totalDebt?.value);
        const maxInstallments = payments.numberOfInstallments;

        return {
            currency: totalAmountCurrency,
            totalDebtInt: totalDebtObj?.value ?? 0,
            totalAmountSelected: totalAmountSelected,
            debtMonths: debtMonthsFinal,
            totalDebt: totalDebt,
            maxInstallments: maxInstallments,
            payments: payments,
            buildingID: props.buildingID,
            apartmentNumber: props.apartmentNumber,
        }
    }

    renderMonths(){
        const {t} = this.props;
        const totalDebtInt = this.state.totalDebtInt;
        const totalAmountSelected = this.state.totalAmountSelected;
        const debtMonths = this.state.debtMonths;
        const maxInstallments = this.state.maxInstallments;

        BllinkLogger.info('rending debt payments total', totalDebtInt);
        BllinkLogger.info(`months this props Debt`, this.props);
        BllinkLogger.info(`months this props state`, this.state);

        // Think empty string may cause an error
        // https://sentry.io/organizations/bllink/issues/2921917867/events/0cf336b3c48b490bbcd9cb04db23f1ab/?project=5424386
        let debtText = null;


       return (
           <div>
               <div id="debt-months" className="payment-box">
                   <h4 className="pt-4 pb-3">{t('payments.debt_title')}</h4>
                   {debtText}
                   <UnpaidMonths
                       months={debtMonths}
                       onChangeFunc={this.debtInputChangedFunc}
                   />

               </div>
               <MonthRelatedSelectBox
                   months={this.state.debtMonths}
                   currency={this.state.currency}
                   maxNumberOfInstallments={maxInstallments}
                   total={totalAmountSelected}
                   name={this.typOfPayment}
                   isViewedAsManager={this.props.isViewedAsManager}
                   buildingID={this.props.buildingID}
                   apartmentNumber={this.props.apartmentNumber}
                   // shouldHideCreditCardOption={this.props.shouldHideCreditCardOption}
               />
           </div>
       )
    }

    render() {

        const debtMonths = this.state.debtMonths;
        let monthHtml;
        BllinkLogger.info(`this props Debt`, this.props);
        this.setBodyClasses(constants.backgroundOptions.debtSelectPayments);
        if (debtMonths.length === 0){
            monthHtml = <AllPaid/>
        }else{
            monthHtml = this.renderMonths()
        }

        return (
            <div className="col-md-12">
                <div className="js-select-payment-form">
                    {monthHtml}
                    {/* requested by rayee via email "if there is an open one time payment for the apartment, lets disable the fast one time from the on-going page"
*/}
                    {this.state.isManager && !this.props.hasOpenOneTimePayment && (
                        <AddFastPayment
                            buildingID={this.props.buildingID}
                            apartmentNumber={this.props.apartmentNumber}
                        />
                    )}

                    {/* todo should be in main selectPayments.js and duplicated in debt, on going and one time */}
                    <BackNextBar
                        buildingID={this.props.buildingID}
                        apartmentNumber={this.props.apartmentNumber}
                        paymentsStats={this.props.paymentsStats}
                        currentTab={constants.pages.debtTab}
                        onNextBackChange={this.props.onChangeNextBack}
                        isViewedAsManager={this.props.isViewedAsManager}
                        shouldHideCreditCardOption={this.props.shouldHideCreditCardOption}
                    />
                </div>
            </div>
        )

    }
}

export default withTranslation()(DebtPaymentsSection);
